<a href="#" (click)="dettaglio()" (keyup.enter)="dettaglio()">
  <div
    class="custom-card-result mb-4"
    [ngClass]="{ 'div-c-border': isCarente() }"
  >
    <div class="n-link d-flex flex-row align-items-center gap-3" href="#">
      <img
        alt=""
        aria-hidden="true"
        src="assets/icons/ic_medicinale_color.png"
      />
      <span
        >{{ formaDosaggio.medicinale.denominazioneMedicinale }} -
        {{ paddingLeft(formaDosaggio.medicinale.aic6) }}</span
      >
    </div>
        <div class="reactive-grid-container">
          <div class="">
              <h4
                class="h4-custom"
                i18n="
                  Messaggio azienda farmaceutica|card risultato ricerca
                  @@forma-dosaggio.card-result.pharmaceutical-company"
              >
                Azienda farmaceutica: <br />
              </h4>
              <h6 class="h6-custom">
                {{ formaDosaggio.medicinale.aziendaTitolare }}
              </h6>
            </div>

          <div class="">
            <h4
              class="h4-custom"
              i18n="
                Messaggio forma farmaceutica|card risultato ricerca
                @@forma-dosaggio.card-result.pharmaceutical-form"
            >
              Forma farmaceutica:
            </h4>
            <h6 class="h6-custom">{{ formaDosaggio.formaFarmaceutica }}</h6>
          </div>

          <div class="">
            <h4
              class="h4-custom"
              i18n="
                Messaggio icona carenza|card risultato ricerca
                @@forma-dosaggio.card-result.dosage"
            >
              Dosaggio:<br />
            </h4>
            <h6 class="h6-custom">{{ formaDosaggio.descrizioneFormaDosaggio }}</h6>
          </div>

          <div class="">
            <h4
              class="h4-custom"
              i18n="
                Messaggio principi attivi|card risultato ricerca
                @@forma-dosaggio.card-result.active-ingredients"
            >
              Principi Attivi:
            </h4>
            <h6 class="h6-custom" *ngFor="let p of formaDosaggio.principiAttiviIt">
              &nbsp;&#9642;&nbsp;{{ p }}
            </h6>
          </div>

          <div class="">
            <h4
              class="h4-custom"
              i18n="
                Messaggio icona carenza|card risultato ricerca
                @@forma-dosaggio.card-result.codeatc"
            >
              ATC:<br />
            </h4>
            <h6 class="h6-custom" *ngFor="let p of formaDosaggio.codiceAtc">
              &nbsp;&#9642;&nbsp;{{ p }}
            </h6>
          </div>

        </div>

      
    <div >
      <p class="text-end" > {{formaDosaggio.position +1}} di {{totalElements}}</p> 

    <div [hidden]="!isCarente()" class="div-c-position mb-2 ms-2" >
      <span
        class="badge rounded-pill bg-danger"
        i18n="Messaggio carenza|card risultato ricerca"
      >
        <img
          alt="Alcune confezioni in carenza"
          i18n-alt="Messaggio icona carenza|card risultato ricerca"
          src="assets/images/ic_carenza.png"
        />
        ALCUNE CONFEZIONI IN CARENZA</span
      >
    </div>
   
  </div>
    
  </div>
  
</a>
